import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class WorkOrderCategory extends Base {
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */
  list(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/cmms/work-order-category?" + queryParam);
    return this._secureFetch(url);
  }
  listByToken(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL(
      "/cmms/work-order-category-by-token?" + queryParam
    );
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */

  create(payload) {
    const url = this._getFullURL("/cmms/work-order-category");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  update(id, payload) {
    const url = this._getFullURL("/cmms/work-order-category/" + id);
    return fetch(url, this._generateRequestBody({ payload, method: "PUT" }));
  }

  delete = (id) => {
    const url = this._getFullURL(`/cmms/work-order-category/${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      })
    );
  };
}
